/*
* @Author: msmiller
* @Date:   2018-11-23 16:21:41
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:22
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2018-10-29 11:14:42
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"
import ClipboardJS from 'clipboard';

export default class extends Controller {

  connect() {
  }

  initialize() {
    var clipboard = new ClipboardJS('.clipboard-btn');
    clipboard.on('success', function(e) {
      alert("URL copied to clipboard.")
    });
  }

};
  
// console.log("-=> clipboard_controller loaded");



